export const chooseMembershipSavingsCopy = (
  hasMembership,
  hasMembershipInBag,
  guestPrice,
  traditionalRetailPrice
) => {
  if (hasMembershipInBag && guestPrice?.formatted) {
    return `(Non-member ${guestPrice.formatted})`;
  }
  if (hasMembership && traditionalRetailPrice?.formatted) {
    return `(Traditional Retail ${traditionalRetailPrice.formatted})`;
  }
  return "";
};
